import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
// @ts-ignore
import * as html2pdf from 'html2pdf.js';
import Chart from 'chart.js/auto';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-pdfpreview',
  templateUrl: './pdfpreview.component.html',
  styleUrls: ['./pdfpreview.component.scss'],
})
export class PdfpreviewComponent implements OnInit, AfterViewInit {
  dateStr: any = '3 Jan 2023';
  hospitalName: any;
  levelTwoName: any;
  showSplitByGender = true;
  context: any;
  @ViewChild('pieChartMain') chartMain!: ElementRef;
  myChart: any;
  fileName: any;
  todayDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.dateStr = this.datePipe.transform(Date.now(), 'd MMM, y');

    Chart.defaults.color = '#ffffff';

    this.hospitalName = this.data.hospitalName;
    this.levelTwoName = this.data.levelTwoName;
    if (this.data.selectedValue === 7) {
      this.fileName = `Tobacco-cessation-dashboard-${this.data.duration}-${this.hospitalName}`;
    } else {
      this.fileName = `Tobacco-cessation-dashboard-${this.data.duration}-from-${this.todayDate}-${this.hospitalName}`;
    }
    if (this.data.selectedValue === 1) {
      this.fileName = `Tobacco-cessation-dashboard-${this.data.duration}-${this.hospitalName}`;
    }
    this.fileName = this.fileName
      .replace(/\s/g, '-')
      .replace(/,/g, '')
      .replace(/---/g, '-');
  }

  ngAfterViewInit(): void {
    // Get canvas which renders the Chart
    this.context = (
      this.chartMain.nativeElement as HTMLCanvasElement
    ).getContext('2d') as unknown as CanvasRenderingContext2D;
    this.loadPieChart();
  }

  legendConfig(): void {
    Chart.defaults.plugins.legend.position = 'bottom';
    Chart.defaults.plugins.legend.align = 'start';
    Chart.defaults.plugins.legend.labels.padding = 30;
    Chart.defaults.plugins.tooltip.enabled = true;
  }

  async loadPieChart(): Promise<any> {
    if (this.data !== null) {
      const piedata: number[] = [];
      const labelList: string[] = [];
      const bgColorList = [];
      if (this.data?.tobaccoFreeData.noReferralToIntensive[0].totalNumber > 0) {
        labelList.push(' Without referral ');
        piedata.push(
          this.data?.tobaccoFreeData.noReferralToIntensive[0].totalNumber
        );
        bgColorList.push('#5cbdfc');
      }
      if (this.data?.tobaccoFreeData.referralToIntensive[0].totalNumber > 0) {
        labelList.push(' Referred, not offered NRT ');
        piedata.push(
          this.data?.tobaccoFreeData.referralToIntensive[0].totalNumber
        );
        bgColorList.push('#006098');
      }
      if (this.data?.tobaccoFreeData.referralWithNrt[0].totalNumber > 0) {
        labelList.push(' Referred & offered NRT ');
        piedata.push(this.data?.tobaccoFreeData.referralWithNrt[0].totalNumber);
        bgColorList.push('#d86422');
      }

      this.myChart = new Chart(this.context, {
        type: 'pie',
        options: {
          responsive: false,
          plugins: {
            datalabels: {
              formatter: (value, ctx) => {
                  let sum = 0;
                  const dataArr = ctx.chart.data.datasets[0].data;
                  dataArr.map((data:any) => {
                      sum += data;
                  });
                  const percentage = (value*100 / sum).toFixed(1)+"%";
                  return percentage;
              },
              color: '#fff',
          },
            legend: {
              display: false,
            },
          },
        },
        data: {
          labels: labelList,
          datasets: [
            {
              data: piedata,
              backgroundColor: bgColorList,
              hoverOffset: 0,
              borderWidth: 0,
            },
          ],
        },
      });
      this.myChart.update();
    }
  }

  htmlToPDF(): void {
    const options = {
      margin: [5, 5, 5, 5],
      filename: this.fileName,
      image: { type: 'png', quality: 1 },
      html2canvas: { letterRendring: true, scale: 1.5, dpi: 192 },
      jsPDF: {
        unit: 'mm',
        format: 'letter',
        orientation: 'portrait',
        compress: true,
      },
      pagebreak: { mode: 'avoid-all', after: '.breakPage' },
    };

    const content: any = document.getElementById('pdfDoc');
    html2pdf().from(content).set(options).toPdf().save();
  }
}
